module.exports = __webpack_public_path__ + "kangping/img/已失效.ab8be907.png";